import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../../../../StateProvider/index.js';
import { fetchGroomingBookings } from '../../../../../../Utilities/api/index.js';
import { BackButton } from '../../../../../../Utilities/components/Buttons/index.js';
import './GroomerAppointments.css';

function GroomerAppointments() {
  var context = useContext(StateContext);
  var user = context.user;
  var navigate = useNavigate();
  var [appointments, setAppointments] = useState([]);

  useEffect(function () {
    function loadAppointments() {
      fetchGroomingBookings()
        .then(function (data) {
          setAppointments(data);
        })
        .catch(function (error) {
          console.error('Failed to fetch grooming appointments:', error);
        });
    }

    loadAppointments();
  }, []);

  function formatTime(iso) {
    var date = new Date(iso);
    return date.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  function getSelectedPetNames(selectedPets) {
    if (!Array.isArray(selectedPets)) {
      return 'No pet name';
    }

    return selectedPets
      .map(function (id, index) {
        return 'Pet ' + (index + 1);
      })
      .join(', ');
  }

  function getStatusBadgeClass(status) {
    var s = status.toLowerCase();
    if (s === 'bathing') return 'badge bathing';
    if (s === 'grooming') return 'badge grooming';
    if (s === 'done') return 'badge done';
    if (s === 'canceled') return 'badge canceled';
    return 'badge scheduled';
  }

  function handleCardClick(appt) {
    navigate('/console/tasks/groomer-appointment-detail/' + appt.id, { state: { appointment: appt } });
  }

  return (
    <div className="groomer-dashboard">
      <BackButton />
      <h2 className="groomer-header">✂️ Grooming Appointments</h2>

      <section className="groomer-section">
        <div className="appointment-list">
          {appointments.map(function (appt) {
            var pet = appt.FamilyMember || {};
            var owner = appt.User || {};

            return (
              <div key={appt.id} className="appointment-card" onClick={function () { handleCardClick(appt); }}>
                <div className={getStatusBadgeClass(appt.status) + ' status-badge'}>{appt.status}</div>
                <h4><span className='pet-name-badge'>{getSelectedPetNames(appt.selectedPets)}</span><span className="pet-type-badge">{pet.type}</span> - <span>{pet.breed}</span></h4>
                <p><strong>Owner:</strong> {owner.username}</p>
                <p><strong>Start:</strong> {formatTime(appt.startTime)}</p>
                <p><strong>End:</strong> {formatTime(appt.endTime)}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default GroomerAppointments;
